import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(_theme => ({
  root: {
    color: '#fff',
    textAlign: 'center'
  }
}))
